import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1541.643 -4099)">
      <path
        d="M102.107.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1628 4099)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M117.107,15.75a15,15,0,0,0-15-15v30a15,15,0,0,0,15-15"
        transform="translate(-1628 4099)"
        fill={color}
      />
    </g>
  </svg>
);
